import * as React from 'react';

// The treatment's icons are 1.5px line drawings in Dark Gray, not the design
// system's filled duotone set — a deliberate choice recorded on the F0 board
// ("Line icon, #616161"). They live here as a small portal-owned set.

const LINE_GLYPH_PROPS = {
  width: 38,
  height: 38,
  viewBox: '0 0 44 44',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round',
  'aria-hidden': true,
} satisfies React.SVGProps<SVGSVGElement>;

/** A company: a main building with an annexe. */
export function OrganizationGlyph() {
  return (
    <svg {...LINE_GLYPH_PROPS}>
      <rect x="7" y="11" width="20" height="27" rx="2" />
      <rect x="27" y="20" width="10" height="18" rx="2" />
      <path d="M12 17h4M18 17h4M12 23h4M18 23h4M12 29h4M18 29h4M31 26h3M31 32h3" />
    </svg>
  );
}

/** A university, government body or nonprofit: a portico. */
export function InstituteGlyph() {
  return (
    <svg {...LINE_GLYPH_PROPS} strokeLinejoin="round">
      <path d="M6 17 L22 8 L38 17" />
      <path d="M11 20v14M17.7 20v14M26.3 20v14M33 20v14" />
      <path d="M6 34h32M8 38h28" />
    </svg>
  );
}

/** An individual consultant: one person. */
export function PersonGlyph() {
  return (
    <svg {...LINE_GLYPH_PROPS}>
      <circle cx="22" cy="16" r="7" />
      <path d="M9 38c0-7.2 5.8-13 13-13s13 5.8 13 13" />
    </svg>
  );
}

// The flask stands taller than the wordmark, as it does in the lockup on
// scienceexchange.com, where the mark spans the logo's full height.
const MARK_HEIGHT = 40;
const MARK_ASPECT = 27 / 40;

/** The Science Exchange flask mark, at the top-bar size. */
export function ScienceExchangeMark() {
  return (
    <svg
      width={Math.round(MARK_HEIGHT * MARK_ASPECT)}
      height={MARK_HEIGHT}
      viewBox="0 0 27 40"
      fill="none"
      aria-hidden="true"
      className="text-brand-black"
    >
      <path
        d="M16.4515 18.8709C16.4855 22.0928 20.9981 27.047 22.808 29.7934C25.2341 33.6752 23.6717 36.7855 19.1203 37.2271H11.7594C12.7589 36.0625 13.7342 34.1362 15.3355 34.1459H18.9213C22.6576 34.1459 19.3095 30.0797 18.1983 28.3814C16.6505 26.0911 13.545 22.9759 13.3849 20.1616V10.064C13.3849 6.49272 13.1714 6.75958 16.2429 9.68065C19.6395 13.1549 20.0325 13.3878 16.5971 13.3927C16.546 13.3939 16.4973 13.4147 16.4612 13.4509C16.4251 13.487 16.4042 13.5357 16.403 13.5868L16.4515 18.8709ZM5.59212 34.1362C0.545746 34.1362 4.9322 29.2839 6.14042 27.5079C7.50391 25.5233 10.2988 22.6557 10.2988 20.2004V10.326C10.2995 10.298 10.2946 10.2701 10.2844 10.2439C10.2743 10.2178 10.2591 10.1939 10.2397 10.1736C10.2204 10.1534 10.1972 10.1371 10.1715 10.1258C10.1459 10.1145 10.1182 10.1083 10.0902 10.1077H8.31909C8.31909 10.1077 7.07691 10.0785 6.59168 10.5929C6.38574 10.7998 6.23839 11.0577 6.16468 11.3402C5.98029 12.3106 6.83915 12.9172 7.21278 13.6547C7.23651 13.7064 7.24812 13.7628 7.24674 13.8197L7.31953 18.9874C7.31953 21.234 4.33052 24.8101 2.91366 26.6782C1.39489 28.7453 -1.07977 32.5543 0.516629 35.1648C1.54531 36.8583 3.77251 37.2173 5.58726 37.2222H6.1016C6.1016 40.7789 6.25202 40.4635 9.8136 37.0087C12.8317 33.913 12.953 34.1507 8.84314 34.1507L5.59212 34.1362Z"
        fill="currentColor"
      />
      <path
        d="M16.5198 29.4632C14.8409 26.9497 14.9671 27.0759 12.2159 27.0759C9.46462 27.0759 9.38698 26.1879 7.74206 28.5849C5.80114 31.4429 4.48132 32.1416 8.22728 32.1513H15.8939C19.0382 32.1513 17.9318 31.5885 16.5247 29.4389L16.5198 29.4632Z"
        fill="currentColor"
      />
    </svg>
  );
}
